import { useNavigate } from 'react-router-dom'
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from 'firebase/auth'

import { AppDispatch } from 'src/store'
import { auth, googleProvider } from 'src/configuration-firebase'

import { RoutesPath } from 'src/types/enums'

import {
  authError,
  loginStart,
  loginSuccess,
  logoutSuccess,
  showPostRegiPopup,
} from 'src/store/reducers/AuthReducer/AuthSlice'

export const signUp =
  (email: string, password: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(loginStart())

      const { user } = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      )

      if (user) {
        localStorage.setItem('authToken', user.refreshToken)
      }

      dispatch(loginSuccess(user))
      dispatch(showPostRegiPopup())
    } catch (error) {
      if (error instanceof Error) {
        dispatch(authError(error.message))
      }

      if (typeof error === 'string') {
        dispatch(authError(error))
      }
    }
  }

export const signIn =
  (
    email: string,
    password: string,
    navigate: { (path: RoutesPath): void; (arg0: RoutesPath): void },
  ) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(loginStart())
      const { user } = await signInWithEmailAndPassword(auth, email, password)

      if (user) {
        localStorage.setItem('authToken', user.refreshToken)
      }

      dispatch(loginSuccess(user))
      navigate(RoutesPath.HOME)
    } catch (error) {
      if (error instanceof Error) {
        dispatch(authError(error.message))
      }

      if (typeof error === 'string') {
        dispatch(authError(error))
      }
    }
  }

export const signInWithGoogle =
  (navigate: { (path: RoutesPath): void; (arg0: RoutesPath): void }) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(loginStart())

      const { user } = await signInWithPopup(auth, googleProvider)

      if (user) {
        localStorage.setItem('authToken', user.refreshToken)
        dispatch(loginSuccess(user))

        const isNewUser =
          user.metadata.creationTime === user.metadata.lastSignInTime

        if (isNewUser) {
          dispatch(showPostRegiPopup())
        } else {
          navigate(RoutesPath.HOME)
        }
      }
    } catch (error) {
      if (error instanceof Error) {
        dispatch(authError(error.message))
      }

      if (typeof error === 'string') {
        dispatch(authError(error))
      }
    }
  }

export const logout =
  (navigate: ReturnType<typeof useNavigate>) =>
  async (dispatch: AppDispatch) => {
    try {
      await signOut(auth)
      localStorage.removeItem('authToken')
      dispatch(logoutSuccess())
      navigate(RoutesPath.LOGIN)
    } catch (error) {
      if (error instanceof Error) {
        dispatch(authError(error.message))
      } else {
        dispatch(authError('An unknown error occurred during logout.'))
      }
    }
  }
